import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';

const ProjectsTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../../../pages/sherlock/projects/projectsTable'
    )
);

export const projectRoutes: PageRouter[] = [
  {
    name: 'open',
    path: '/open',
    component: ProjectsTable,
    exact: true,
    tabs: []
  },
  {
    name: 'archive',
    path: '/archive',
    component: ProjectsTable,
    exact: true,
    tabs: []
  }
];
